import { Box } from "@chakra-ui/react";
import { MotionGrid as Grid, viewAppearDefault } from "utils/motion";
import Text from "components/base/Text";
import Description from "components/base/Description";
import Container from "components/base/Container";
import ArrowButton from "components/blocks/ArrowButton";

export default function TextColumnSection({
  title,
  subtitle,
  subtitle2,
  titleType,
  subtitleType,
  text,
  noCTA,
  CTA,
  inverted,
  bg,
  children,
}) {
  const textColor = inverted ? "black.900" : "white";

  return (
    <Box
      width="100%"
      bg={bg || (inverted ? "white" : "black.900")}
      px={[6, null, 20]}
    >
      <Container as="section" centerContent px={0}>
        <Grid
          variants={viewAppearDefault}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          width="100%"
          templateColumns={["1fr", null, "1fr 1fr"]}
          gap={[6, null, 8, 20]}
          mx={0}
        >
          <Box>
            <Text type={titleType || "title_md"} color="primary" mb="xs">
              {title}
            </Text>
            <Text type={subtitleType || "headline_md"} color={textColor} w="90%">
              {subtitle}
            </Text>
          </Box>
          <Box mt={subtitle2 ? "sm" : 0}>
            {subtitle2 && (
              <Text type="title_md" mb="md" color={textColor} fontWeight="500">
                {subtitle2}
              </Text>
            )}
            {children ? (
              children
            ) : (
              <Description color={textColor}>{text}</Description>
            )}
            {!noCTA && (CTA || (
              <ArrowButton
                mt="xl"
                aria-label="ga2"
                trackLabel="ga_learn_more"
                href="/general-aviation-20"
              />
            ))}
          </Box>
        </Grid>
      </Container>
    </Box>
  );
}
